import { useState } from 'react';

import { colorFor, COLORS } from '../styles/tokens';
import styles from './Avatar.module.css';
import { cx } from './cx';

export interface AvatarProps {
  name: string;
  src?: string | null;
  /** Diameter in px (Figma: 40 HUD, 48 queue row, 64 component, 160 profile). */
  size?: 40 | 48 | 64 | 160;
  className?: string;
}

const AVATAR_PALETTE = [COLORS.blue, COLORS.green, COLORS.cyan, COLORS.purple, COLORS.amber];

export function Avatar({ name, src, size = 48, className }: AvatarProps) {
  const [broken, setBroken] = useState(false);
  const initial = (name.trim().charAt(0) || '?').toUpperCase();
  const showImage = Boolean(src) && !broken;
  return (
    <span
      className={cx(styles.avatar, className)}
      style={{
        width: size,
        height: size,
        fontSize: Math.round(size * 0.46),
        background: showImage ? undefined : colorFor(name, AVATAR_PALETTE),
      }}
      aria-label={name}
    >
      {showImage ? (
        <img src={src ?? undefined} alt="" loading="lazy" onError={() => setBroken(true)} />
      ) : (
        initial
      )}
    </span>
  );
}
